/* eslint import/prefer-default-export: 0 */
export const ACCESSORIAL_PDFS = {
    shipper: 'http://docs.cargomatic.com/shipper-short-haul-accessorials-2016.pdf',
    carrier: 'http://docs.cargomatic.com/carrier-accessorials-2022.pdf',
};
